import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';

export interface PaymentApprovalCommentModalParams {
    paymentCount: number;
    currentComment?: string;
}

export interface PaymentApprovalCommentModalResult {
    comment: string;
}

@Component({
    selector: 'payment-approval-comment-modal',
    templateUrl: './paymentApprovalCommentModal.component.html',
    standalone: false,
})
export class PaymentApprovalCommentModalComponent
    implements OnInit, IWeissmanModalComponent<PaymentApprovalCommentModalParams, PaymentApprovalCommentModalResult>
{
    constructor(private readonly bsModalRef: BsModalRef) {}

    params: PaymentApprovalCommentModalParams;
    result: PaymentApprovalCommentModalResult;
    comment: string = '';

    get headerLabel(): string {
        const count = this.params.paymentCount;
        return `Update Approval Comment for ${count} ${count === 1 ? 'Payment' : 'Payments'}`;
    }

    get disableSave(): boolean {
        return !this.comment.trim();
    }

    ngOnInit(): void {
        this.comment = this.params.currentComment ?? '';
    }

    save(): void {
        if (this.disableSave) {
            return;
        }
        this.result = { comment: this.comment.trim() };
        this.bsModalRef.hide();
    }

    cancel(): void {
        this.bsModalRef.hide();
    }
}
